var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoteUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boxicons:arrow-big-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 14H8V21C8 21.55 8.45 22 9 22H15C15.55 22 16 21.55 16 21V14H20C20.1886 13.9991 20.3731 13.9451 20.5324 13.8441C20.6917 13.7432 20.8193 13.5995 20.9007 13.4294C20.9821 13.2593 21.014 13.0697 20.9926 12.8823C20.9713 12.695 20.8976 12.5174 20.78 12.37L12.78 2.38C12.4 1.91 11.6 1.91 11.22 2.38L3.22 12.38C3.10242 12.5274 3.02874 12.705 3.00739 12.8923C2.98604 13.0797 3.01789 13.2693 3.09929 13.4394C3.18068 13.6095 3.30834 13.7532 3.46764 13.8541C3.62693 13.9551 3.81143 14.0091 4 14.01V14ZM12 4.6L17.92 12H15C14.45 12 14 12.45 14 13V20H10V13C10 12.45 9.55 12 9 12H6.08L12 4.6Z",
    fill: "#656565"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteUp);
export default __webpack_public_path__ + "static/media/vote-up.296e1cd2aefeaa3df7814b5f0ddf007f.svg";
export { ForwardRef as ReactComponent };